
import { Injectable } from '@angular/core';
import { SpellCheckWordStatus } from 'src/app/core/html-and-text-utils';
import { environment } from 'src/environments/environment';
import { DocumentManagerService } from '../document/document-manager.service';

export interface ISpellCheckWord {
  word: string;
  correct: boolean;
  status: SpellCheckWordStatus;
  suggestions: string[];
}

export interface ISpellCheckLangugeStore {
  langCode: string;
  words: ISpellCheckWord[];
}

@Injectable({
  providedIn: 'root'
})
export class SpellCheckStorageService {
  private get spellCheckStorage(): ISpellCheckLangugeStore[] | undefined {
    if (this.docId) {
      if (!this.documentSpellCheckStorageMap) {
        this.documentSpellCheckStorageMap = new Map();
      }
      const storage = this.documentSpellCheckStorageMap.get(this.docId);
      if (storage) {
        return storage;
      } else {
        if (this.currentDocId) {
          this.documentSpellCheckStorageMap.set(this.currentDocId, this.createStorage());
          return this.documentSpellCheckStorageMap.get(this.currentDocId);
        }
      }
    }
  }
  private documentSpellCheckStorageMap: Map<string, ISpellCheckLangugeStore[]> | null = null;
  private currentDocId: string | null = null;

  private get docId(): string | null {
    return this.currentDocId;
  }

  constructor(
    private docMgrService: DocumentManagerService
  ) {
    this.init();
  }

  init = () => {
    this.docMgrService.currentDocumentChanged.subscribe(e => {
      this.currentDocId = e;
    });
    this.docMgrService.documentRemoved.subscribe(e => {
      if (this.documentSpellCheckStorageMap && e) {
        this.documentSpellCheckStorageMap.delete(e);
      }
    });
  }

  addWordToStorage(langCode: string, word: ISpellCheckWord): void {
    if (this.spellCheckStorage) {
      const langStorage = this.spellCheckStorage.find(x => x.langCode === langCode);
      if (langStorage && langStorage.words) {
        const existingWord = langStorage.words.find(x => x.word === word.word);

        if (existingWord) {
          existingWord.correct = true;
          existingWord.status = SpellCheckWordStatus.VALID;
        } else {
          langStorage.words.push(word);
        }
      }
    }
  }

  deleteWordFromStorage(langCode: string, word: string): void {
    if (this.spellCheckStorage) {
      const langStorage = this.spellCheckStorage.find(x => x.langCode === langCode);

      if (langStorage && langStorage.words) {
        const wordIdx = langStorage.words.findIndex(x => x.word === word);

        if (wordIdx > -1) {
          langStorage.words.splice(wordIdx, 1);
        }
      }
    }
  }

  getWordsForLang(langCode: string): ISpellCheckLangugeStore | undefined {
    if (this.spellCheckStorage) {
      return this.spellCheckStorage.find(r => r.langCode === langCode);
    }
  }

  cleanOnDestroy(): void {
    if (this.documentSpellCheckStorageMap) {
      this.documentSpellCheckStorageMap.clear();
    }
  }

  private createStorage(): {langCode: string, words: any}[] {
    return environment.spellCheck.supportedLangCodes.map(x => ({ langCode: x, words: [] }));
  }
}
